import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents, CartUpdateEvent } from '@theme/events';

class CartIcon extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleText', 'cartBubbleCount'];

  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent ?? '0', 10);
  }

  set currentCartCount(value) {
    this.refs.cartBubbleCount.textContent = value < 100 ? String(value) : '';
  }



  connectedCallback() {
  super.connectedCallback();
  document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  window.addEventListener('pageshow', this.onPageShow);
  document.addEventListener('visibilitychange', this.onVisibilityChange);
  
  // ✅ YEH ADD KARO - cartAdd event bhi suno
  document.addEventListener(ThemeEvents.cartAdd, this.onCartUpdate);
  
  this.ensureCartBubbleIsCorrect();
}


disconnectedCallback() {
  super.disconnectedCallback();
  document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  window.removeEventListener('pageshow', this.onPageShow);
  document.removeEventListener('visibilitychange', this.onVisibilityChange);
  
  // ✅ YEH ADD KARO
  document.removeEventListener(ThemeEvents.cartAdd, this.onCartUpdate);
}

  onPageShow = (event) => {
    if (event.persisted) {
      this.fetchAndUpdateCartCount();
    }
  };

  onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      this.fetchAndUpdateCartCount();
    }
  };

  // ✅ NEW: Always fetch real count from Shopify
  fetchAndUpdateCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js?_=${Date.now()}`);
      const cart = await response.json();
      this.renderCartBubble(cart.item_count, false, false);
    } catch (_) {
      this.ensureCartBubbleIsCorrect();
    }
  };

  // ✅ FIXED: Real fetch instead of incremental count
  onCartUpdate = async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js?_=${Date.now()}`);
      const cart = await response.json();
      this.renderCartBubble(cart.item_count, false);
    } catch (_) {
      const itemCount = event.detail.cart?.item_count ?? (this.currentCartCount + 1);
      this.renderCartBubble(itemCount, false);
    }
  };

  renderCartBubble = async (itemCount, comingFromProductForm, animate = true) => {
    this.refs.cartBubbleCount.classList.toggle('hidden', itemCount === 0);
    this.refs.cartBubble.classList.toggle('visually-hidden', itemCount === 0);

    this.currentCartCount = itemCount;

    this.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);

    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(itemCount),
        timestamp: Date.now(),
      })
    );

    if (!animate || itemCount === 0) return;

    await new Promise((resolve) => requestAnimationFrame(resolve));
    this.refs.cartBubble.classList.add('cart-bubble--animating');
    await onAnimationEnd(this.refs.cartBubbleText);
    this.refs.cartBubble.classList.remove('cart-bubble--animating');
  };

  ensureCartBubbleIsCorrect = () => {
    if (!this.refs.cartBubbleCount) return;

    const sessionStorageCount = sessionStorage.getItem('cart-count');
    if (sessionStorageCount === null) return;

    const visibleCount = this.refs.cartBubbleCount.textContent;

    try {
      const { value, timestamp } = JSON.parse(sessionStorageCount);
      if (value === visibleCount) return;
      if (Date.now() - timestamp < 100000) {
        const count = parseInt(value, 10);
        if (count >= 0) {
          this.renderCartBubble(count, false, false);
        }
      }
    } catch (_) {
      // no-op
    }
  };
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
